var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    class: _vm.css,
    attrs: {
      src: _vm.image.url,
      srcset: _vm.srcset,
      sizes: _vm.sizes,
      alt: _vm.image.alt,
      title: _vm.image.title,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }